import React from 'react';
import VehicleForm from './VehicleForm.js';
import {useParams} from "react-router-dom"
export default function AddVehicleForUser() {
  const { id } = useParams();
  return <VehicleForm userId={Number(id)}/>;
}
